const $body = $('body')

$('.js-menuBurger').on('click', () => {
  $body.toggleClass('is-menu-open')
})

$('.menu-nav').prepend($('.header-nav').clone())

$('.menu-button').on('click', () => {
  $body.removeClass('is-menu-open')
})
